global.version = "1.0.25";

global.menu_admin = [
    { title: "main_menu" },
    { icon: "\uf0e4", name: "dashboard", link: "/ad/dashboard", permission: "dashboard-admin.read", component: "🟢" },
    { icon: "\uf01c", name: "work_requests", link: "/ad/work-requests", permission: "wr.read", component: "🟢" },
    { icon: "\uf46d", name: "work_orders", link: "/ad/work-orders", permission: "wo.read", component: "🟡" },
    { icon: "\uf073", name: "scheduling", link: "/ad/scheduling", permission: "scheduling.read", component: "🟢" },
    { icon: "\uf073", name: "sales_visit_planning", link: "/ad/sales-visit-planning", permission: "sale-planning.read", component: "🟢" },
    { title: "preventive_maintenance" },
    { icon: "\uf46c", name: "inspection_plan", link: "/ad/inspection-plan", permission: "inspection-plan.read", component: "🟢" },
    { icon: "\uf201", name: "pm_dashboard", link: "/ad/pm-dashboard", permission: "pm.read", component: "🟢" },
    { icon: "\uf03a", name: "checklist_templates", link: "/ad/checklist-templates", permission: "checklist-templates.read", component: "🟢" },
    { title: "reports_analytics" },
    { icon: "\uf15c", name: "work_order_summary", link: "/ad/work-order-summary", permission: "dashboard-admin.read", component: "🟢" },
    { icon: "\uf058", name: "pm_compliance", link: "/ad/pm-compliance", permission: "dashboard-admin.read", component: "🟢" },
    { icon: "\uf200", name: "asset_report", link: "/ad/asset-report", permission: "dashboard-admin.read", component: "🟢" },
    // { icon: "\uf571", name: "cost_report", link: "/ad/cost-report", permission: "dashboard-admin.read", component: "🟢" },
    // { icon: "\uf1da", name: "audit_logs", link: "/ad/audit-logs", permission: "", component: "🟡" },
    { title: "master_data" },
    { icon: "\uf007", name: "customers", link: "/ad/customers", permission: "customers.read", component: "🟢" },
    { icon: "\uf007", name: "sale", link: "/ad/sale", permission: "sale-master.read", component: "🟢" },
    { icon: "\uf007", name: "finance", link: "/ad/finance", permission: "finance-master.read", component: "🟢" },
    { icon: "\uf1b3", name: "assets", link: "/ad/assets", permission: "asset.read", component: "🟢" },
    { icon: "\uf0ad", name: "technicians", link: "/ad/technicians", permission: "technicians.read", component: "🟢" },
    { icon: "\uf140", name: "objectives", link: "/ad/objectives", permission: "objective.read", component: "🟢" },
    { icon: "\uf132", name: "customer_warranty_conditions", link: "/ad/customer-warranty-conditions", permission: "customer-warranty-condition.read", component: "🟢" },
    { title: "user_management" },
    { icon: "\uf0c0", name: "users", link: "/ad/users", permission: "users.read", component: "🟢" },
    { icon: "\uf084", name: "roles", link: "/ad/roles", permission: "roles.read", component: "🟢" },
    { icon: "\uf508", name: "department", link: "/ad/departments", permission: "departments.read", component: "🟢" },
    { title: "settings" },
    { icon: "\uf013", name: "workrequest-config-wireframe", link: "/ad/workrequest-config-wireframe", permission: "wr-category.read", component: "🟢" },
    { icon: "\uf013", name: "req_category", link: "", permission: "wr-category.read" },
    { icon: "\uf013", name: "service_type", link: "", permission: "wr-service-type.read" },
    { icon: "\uf013", name: "priority_level", link: "", permission: "wr-priority.read" },
    { icon: "\uf013", name: "reject_reason", link: "", permission: "wr-reject-reason.read" },
    { icon: "\uf013", name: "service-bom-config", link: "/ad/service-bom-config", permission: "bom-master.read", component: "🟢" },
    // { icon: "\uf013", name: "setting", link: "/ad/settings", permission: "settings.read" },
];

global.menu_customer = [
    { title: "overview" },
    { icon: "\uf0e4", name: "dashboard", link: "/cs/dashboard", permission: "dashboard-customer.read", component: "🟡" },
    { icon: "\uf1b2", name: "my_assets", link: "/cs/assets", permission: "asset.read", component: "🟡" },
    { title: "work_management" },
    { icon: "\uf0ae", name: "work_requests", link: "/cs/work-requests", permission: "wo.read", component: "🟡" },
    { icon: "\uf073", name: "appointments", link: "/cs/appointments", permission: "wo.read", component: "🟡" },
    { title: "asset_service_info" },
    { icon: "\uf1da", name: "service_history", link: "/cs/service-history", permission: "wo.read", component: "🟡" },
    { icon: "\uf15c", name: "service_summary", link: "/cs/service-summary", permission: "wo.read", component: "🟡" },
    { title: "report" },
    { icon: "\uf466", name: "asset_report", link: "/cs/asset-report", permission: "wo.read", component: "🟡" },
    { icon: "\uf155", name: "cost_report", link: "/cs/cost-report", permission: "wo.read", component: "🟡" },
    { icon: "\uf201", name: "sla_report", link: "/cs/sla-report", permission: "wo.read", component: "🟡" },
];

global.menu_warehouse = [
    { title: "overview" },
    { icon: "\uf0e4", name: "dashboard", link: "/wh/dashboard", permission: "dashboard-warehouse.read", component: "🟢" },
    { title: "asset_management" },
    { icon: "\uf1b3", name: "assets", link: "/wh/assets", permission: "warehouse-asset.read", component: "🟢" },
    { title: "inventory_management" },
    { icon: "\uf468", name: "stock", link: "/wh/stock", permission: "stock.read", component: "🟢" },
    // { icon: "\uf0ad", name: "mechanic_inventory", link: "/wh/technician-stock", permission: "stock-technician.read", component: "🟡" },
    { icon: "\uf02d", name: "parts_information", link: "/wh/part-master", permission: "part-master.read", component: "🟢" },
    { title: "parts_movements" },
    { icon: "\uf56d", name: "goods_issue", link: "/wh/goods-issue", permission: "stock-withdraw.read", component: "🟢" },
    // { icon: "\uf01e", name: "parts_returning", link: "/wh/parts-return", permission: "stock-return.read", component: "🟡" },
    // { icon: "\uf24e", name: "stock_counting", link: "/wh/stock-audit", permission: "stock-audit.read", component: "🟡" },
    { icon: "\uf24e", name: "adjustment_stocks", link: "/wh/adjustment-stocks", permission: "stock-adjustment.read", component: "🟢" },
    { title: "procurement" },
    { icon: "\uf543", name: "pr_po", link: "/wh/pr-po", permission: "pr.read", component: "🟢" },
    { icon: "\uf46c", name: "goods_receiving", link: "/wh/goods-receipt", permission: "gr.read", component: "🟢" },
    { title: "supplier_management" },
    // { icon: "\uf3ed", name: "supplier_claims", link: "/wh/stock-claim", permission: "stock-claim.read", component: "🟡" },
    { icon: "\uf0c0", name: "suppliers", link: "/wh/supplier", permission: "supplier.read", component: "🟢" },
    { title: "master_data" },
    { icon: "\uf494", name: "warehouse", link: "/wh/warehouse", permission: "warehouse.read", component: "🟢" },
    { icon: "\uf3c5", name: "location", link: "/wh/location", permission: "location.read", component: "🟢" },
    { icon: "\uf546", name: "uoms", link: "/wh/uoms", permission: "uoms.read", component: "🟢" },
    { icon: "\uf5fd", name: "type", link: "/wh/part-categories", permission: "part-categories.read", component: "🟢" },
    { icon: "\uf02c", name: "brand_header", link: "/wh/brands", permission: "brands.read", component: "🟢" },
    { icon: "\uf1b2", name: "models_1", link: "/wh/models", permission: "models.read", component: "🟢" },
    { icon: "\uf233", name: "models_2", link: "/wh/series", permission: "serie.read", component: "🟢" },
    { icon: "\uf27a", name: "reasons", link: "/wh/reasons", permission: "reason.read", component: "🟢" },
    { icon: "\uf1ad", name: "branches", link: "/wh/branches", permission: "branch.read", component: "🟢" },
    { title: "data_tools" },
    { icon: "", name: "import_center", link: "/wh/import-center", permission: "import-center.read", component: "🟢" },
    // { title: "settings" },
    // { icon: "\uf013", name: "setting", link: "/wh/settings", permission: "settings.read", component: "🟢" },
];

global.menu_super_user = [
  { title: "main" },
  { icon: "\uf0ac", name: "company_management", link: "/su/companies", permission: "companies.read", component: "🟢" },
];

global.permission = [
    // ADMIN
    "dashboard-admin.read",
    "dashboard-admin.create",
    "dashboard-admin.update",
    "dashboard-admin.delete",

    "asset.read",
    "asset.create",
    "asset.update",
    "asset.delete",

    "assets-report.read",
    "assets-report.create",
    "assets-report.update",
    "assets-report.delete",

    "audit-logs.read",
    "audit-logs.create",
    "audit-logs.update",
    "audit-logs.delete",

    "bom-master.read",
    "bom-master.create",
    "bom-master.update",
    "bom-master.delete",

    "checklist-templates.read",
    "checklist-templates.create",
    "checklist-templates.update",
    "checklist-templates.delete",

    "companies.read",
    "companies.create",
    "companies.update",
    "companies.delete",

    "cost-report.read",
    "cost-report.create",
    "cost-report.update",
    "cost-report.delete",

    "customers.read",
    "customers.create",
    "customers.update",
    "customers.delete",

    "dashboard.read",
    "dashboard.create",
    "dashboard.update",
    "dashboard.delete",

    "departments.read",
    "departments.create",
    "departments.update",
    "departments.delete",

    "finance-master.read",
    "finance-master.create",
    "finance-master.update",
    "finance-master.delete",

    "inspection-plan.read",
    "inspection-plan.create",
    "inspection-plan.update",
    "inspection-plan.delete",

    "part-controls.read",
    "part-controls.create",
    "part-controls.update",
    "part-controls.delete",

    "permissions.read",
    "permissions.create",
    "permissions.update",
    "permissions.delete",

    "pm.read",
    "pm.create",
    "pm.update",
    "pm.delete",

    "pm-report.read",
    "pm-report.create",
    "pm-report.update",
    "pm-report.delete",

    "roles.read",
    "roles.create",
    "roles.update",
    "roles.delete",

    "sale-master.read",
    "sale-master.create",
    "sale-master.update",
    "sale-master.delete",

    "objective.read",
    "objective.create",
    "objective.update",
    "objective.delete",

    "customer-warranty-condition.read",
    "customer-warranty-condition.create",
    "customer-warranty-condition.update",
    "customer-warranty-condition.delete",

    "sale-planning.read",
    "sale-planning.create",
    "sale-planning.update",
    "sale-planning.delete",

    "scheduling.read",
    "scheduling.create",
    "scheduling.update",
    "scheduling.delete",

    "service-bom.read",
    "service-bom.create",
    "service-bom.update",
    "service-bom.delete",

    "technicians.read",
    "technicians.create",
    "technicians.update",
    "technicians.delete",

    "users.read",
    "users.create",
    "users.update",
    "users.delete",

    "wo.read",
    "wo.create",
    "wo.update",
    "wo.delete",

    "wo-report.read",
    "wo-report.create",
    "wo-report.update",
    "wo-report.delete",

    "wr.read",
    "wr.create",
    "wr.update",
    "wr.delete",

    "wr-category.read",
    "wr-category.create",
    "wr-category.update",
    "wr-category.delete",

    "wr-reject-reason.read",
    "wr-reject-reason.create",
    "wr-reject-reason.update",
    "wr-reject-reason.delete",

    "wr-priority.read",
    "wr-priority.create",
    "wr-priority.update",
    "wr-priority.delete",

    "wr-service-type.read",
    "wr-service-type.create",
    "wr-service-type.update",
    "wr-service-type.delete",

    "dashboard-customer.read",
    "dashboard-customer.create",
    "dashboard-customer.update",
    "dashboard-customer.delete",

    // WAREHOUSE
    "dashboard-warehouse.read",
    "dashboard-warehouse.create",
    "dashboard-warehouse.update",
    "dashboard-warehouse.delete",

    "brands.read",
    "brands.create",
    "brands.update",
    "brands.delete",

    "gr.read",
    "gr.create",
    "gr.update",
    "gr.delete",

    "location.read",
    "location.create",
    "location.update",
    "location.delete",

    "models.read",
    "models.create",
    "models.update",
    "models.delete",

    "part-categories.read",
    "part-categories.create",
    "part-categories.update",
    "part-categories.delete",

    "part-master.read",
    "part-master.create",
    "part-master.update",
    "part-master.delete",

    "po.read",
    "po.create",
    "po.update",
    "po.delete",

    "pr.read",
    "pr.create",
    "pr.update",
    "pr.delete",

    "reason.read",
    "reason.create",
    "reason.update",
    "reason.delete",

    "branch.read",
    "branch.create",
    "branch.update",
    "branch.delete",

    "serie.read",
    "serie.create",
    "serie.update",
    "serie.delete",

    "stock.read",
    "stock.create",
    "stock.update",
    "stock.delete",

    "stock-audit.read",
    "stock-audit.create",
    "stock-audit.update",
    "stock-audit.delete",

    "stock-adjustment.read",
    "stock-adjustment.create",
    "stock-adjustment.update",
    "stock-adjustment.delete",

    "stock-claim.read",
    "stock-claim.create",
    "stock-claim.update",
    "stock-claim.delete",

    "stock-return.read",
    "stock-return.create",
    "stock-return.update",
    "stock-return.delete",

    "stock-technician.read",
    "stock-technician.create",
    "stock-technician.update",
    "stock-technician.delete",

    "stock-withdraw.read",
    "stock-withdraw.create",
    "stock-withdraw.update",
    "stock-withdraw.delete",

    "supplier.read",
    "supplier.create",
    "supplier.update",
    "supplier.delete",

    "uoms.read",
    "uoms.create",
    "uoms.update",
    "uoms.delete",

    "warehouse.read",
    "warehouse.create",
    "warehouse.update",
    "warehouse.delete",

    "import-center.read",
    "import-center.create",
    "import-center.update",
    "import-center.delete",

    "warehouse-asset.read",
    "warehouse-asset.create",
    "warehouse-asset.update",
    "warehouse-asset.delete",
];

global.bank = [
  { icon: "CIMB.png", value: "CIMB", label: "CIMB Thai", name_th: "ธนาคารซีไอเอ็มบีไทย", code: "022",},
  { icon: "LHB.png", value: "LHB", label: "Land and Houses Bank", name_th: "ธนาคารแลนด์แอนด์เฮ้าส์", code: "073",},
  { icon: "TCRB.png", value: "TCRB", label: "The Thai Credit Retail Bank", name_th: "ธนาคารไทยเครดิตเพื่อรายย่อย", code: "071",},
  { icon: "KKP.png", value: "KKP", label: "Kiatnakin Bank", name_th: "ธนาคารเกียรตินาคิน", code: "069",},
  { icon: "TISCO.png", value: "TISCO", label: "Tisco Bank", name_th: "ธนาคารทิสโก้", code: "067",},
  { icon: "IBANK.png", value: "IBANK", label: "Islamic Bank of Thailand", name_th: "ธนาคารอิสลามแห่งประเทศไทย", code: "066",},
  { icon: "HSBC.png", value: "HSBC", label: "Hong Kong & Shanghai Corporation", name_th: "ฮ่องกงและเซี่ยงไฮ้แบงกิ้งคอร์ปอเรชั่น", code: "030",},
  { icon: "UOB.png", value: "UOB", label: "United Overseas Bank", name_th: "ธนาคารยูโอบี (ไทย)", code: "024",},
  { icon: "ICBC.png", value: "ICBC", label: "Industrial and Commercial Bank of China Limited", name_th: "ธนาคารพาณิชย์อุตสาหกรรมแห่งประเทศจีน", code: "070",},
  { icon: "BAAC.png", value: "BAAC", label: "Bank for Agriculture and Agricultural Cooperatives", name_th: "ธ.ก.ส.", code: "034",},
  { icon: "GHB.png", value: "GHB", label: "Government Housing Bank", name_th: "ธนาคารอาคารสงเคราะห์", code: "033",},
  { icon: "GSB.png", value: "GSB", label: "Government Savings Bank", name_th: "ธนาคารออมสิน", code: "030",},
  { icon: "BAY.png", value: "BAY", label: "Bank of Ayudhya", name_th: "ธนาคารกรุงศรีอยุธยา", code: "025",},
  { icon: "KTB.png", value: "KTB", label: "Krung Thai Bank", name_th: "ธนาคารกรุงไทย", code: "006",},
  { icon: "BBL.png", value: "BBL", label: "Bangkok Bank", name_th: "ธนาคารกรุงเทพ", code: "002",},
  { icon: "TTB.png", value: "TTB", label: "TTB Thanachart Bank", name_th: "ธนาคารทหารไทยธนชาต", code: "011",},
  { icon: "KBANK.png", value: "KBANK", label: "Kasikorn Bank", name_th: "ธนาคารกสิกรไทย", code: "004",},
  { icon: "SCB.png", value: "SCB", label: "Siam Commercial Bank", name_th: "ธนาคารไทยพาณิชย์", code: "014",},

];